import OutlinedCloseIcon from "../../svgIcons/OtlinedCloseIcon";
import styles from "./viewConcierge.module.css"
import parsePhoneNumberFromString from "libphonenumber-js";
import moment from "moment";


interface ConciergeData {
    setOpen: (open: boolean) => void;
    conciergeDataList: {
        id: string;
        name: string;
        fullName: string;
        reservedDate: string;
        startTime: string;
        email: string;
        phoneNumber: string;
        property: string;
        managementCompany: string;
    };
}
export default function ViewConcierge({ setOpen, conciergeDataList }: ConciergeData) {
    const handleClose = () => {
        setOpen(false);
    };

    function formatPhone(phone?: string): string {
        if (!phone) return '';
        const parsed = parsePhoneNumberFromString(phone);
        return parsed ? parsed.formatInternational() : phone;
    }
    return (
        <div className={styles.modalContainer}>
            <div className={styles.modalHeader}>
                <div className={styles.headerContent}>
                    <div className={styles.vendorInfo}>
                        <div className={styles.vendorDetails}>
                            <h2 className={styles.vendorName}>{conciergeDataList?.fullName}</h2>
                            <p className={styles.appointmentId}>Property: {conciergeDataList?.name}</p>
                        </div>
                    </div>
                    <div className={styles.eventBadgeWrapper}>
                        <span className={styles.eventBadge}>
                            {conciergeDataList?.managementCompany}
                        </span>
                    </div>
                </div>
                <button className={styles.closeButton} onClick={handleClose} aria-label="Close modal">
                    <OutlinedCloseIcon fill="#fff" />
                </button>
            </div>

            {/* Modal Body */}
            <div className={styles.modalBody}>
                <div className={styles.twoColumnLayout}>
                    {/* Reserved Date */}
                    <div className={styles.infoItem}>
                        <div className={styles.infoContent}>
                            <label className={styles.infoLabel}>Reserved Date</label>
                            <span className={styles.infoValue}>
                                {conciergeDataList?.reservedDate
                                    ? moment.utc(conciergeDataList.reservedDate).format("MM-DD-YYYY")
                                    : "-"}
                            </span>
                        </div>
                    </div>

                    {/* Reserved Time */}
                    <div className={styles.infoItem}>
                        <div className={styles.infoContent}>
                            <label className={styles.infoLabel}>Start Time</label>
                            <span className={styles.infoValue}>
                                {conciergeDataList?.startTime
                                    ? (moment(conciergeDataList.startTime, ["hh:mm A", "h:mm A", "HH:mm"], true).isValid()
                                        ? moment(conciergeDataList.startTime, ["hh:mm A", "h:mm A", "HH:mm"]).format("hh:mm A")
                                        : conciergeDataList.startTime)
                                    : "-"}
                            </span>
                        </div>
                    </div>

                    {/* Email */}
                    <div className={styles.infoItem}>
                        <div className={styles.infoContent}>
                            <label className={styles.infoLabel}>Email</label>
                            <span className={styles.infoValue}>{conciergeDataList?.email || "N/A"}</span>
                        </div>
                    </div>

                    {/* Phone */}
                    <div className={styles.infoItem}>
                        <div className={styles.infoContent}>
                            <label className={styles.infoLabel}>Phone</label>
                            <span className={styles.infoValue}>{conciergeDataList?.phoneNumber ? formatPhone(`+${conciergeDataList?.phoneNumber}`) : "N/A"}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}